import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'
import React from 'react'
import { ToolEditor } from '../app-connection/components/tool-editor'
import { CampaignLanguageSettings } from '../campaign/components/campaign-language-settings'
import { CampaignInterviewSettingsSection } from '../campaign/components/settings/campaign-interview-settings-section'
import { CampaignPromptSection } from '../campaign/components/settings/campaign-prompt-section'
import { useCampaign } from '../campaign/hooks'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/content')({
    component: CampaignSettingsContent,
})

function CampaignSettingsContent() {
    const { campaignId } = Route.useParams()
    const campaign = useCampaign(campaignId)

    if (campaign.isPending || campaign.isError) {
        return null
    }

    if (campaign.data.type === 'interview') {
        return <CampaignInterviewSettingsSection />
    }

    return (
        <Flex
            vertical
            gap="large"
        >
            <CampaignPromptSection />
            {campaign.data.type === 'custom' && <ToolEditor />}
            <CampaignLanguageSettings />
        </Flex>
    )
}
